module.exports = __webpack_public_path__ + "img/login.38aa4a11.png";